// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify, ThemeDefinition } from 'vuetify';
import * as directives from 'vuetify/directives';

const myCustomLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    surface: '#ffffff',
    muted: '#E3DDE3',
    // primary
    primary: '#9B267C',
    'primary-dark': '#3A0D2E',
    'primary-dark-1': '#600949',
    'pd-primary': '#77206e',
    'primary-light': '#D160B0',
    'primary-light-1': '#F7B9DD',
    'primary-light-2': '#E6C8DE',
    'primary-light-3': '#FFEFF7',

    // secondary
    secondary: '#e5d5e1',
    'secondary-lighten-1': '#C0D4A6',

    //tertiary
    tertiary: '#CAD404',
    'tertiary-green': '#9bc53d',
    danger: '#BC1224',
    info: '#397FDB',
    success: '#0A7F31',
    warning: '#C8C958',
  },
};

export default createVuetify({
  components: {},
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    },
  },
  directives,
});
